<!-- TEMPLATE DE LAS EXPERIENCIAS, DE CADA CATEGORÍA-->

<template lang="html">

  <div class="wrapper -categoria" :data="$route.params.id" v-if="categoria">


    <section class="intro categoria column-center" v-if="childs.length > 0" :data="$route.params.id" :style="`background:url(${categoria.image.url}) center/cover no-repeat;`">

      <h1 class="big-title mt0 column-center">
        <span>Actividades de Jaén Paraíso Interior</span>
        <span v-if="!!categoria.header">{{categoria.header}}</span>
        <span v-else>A vivir experiencias</span>
      </h1>

    </section>

    <section class="breadcrumb" v-if="categoria">
      <nav class="container row-start">
        <router-link to="/">Home SARA</router-link>
        <a>{{categoria.name}}</a>
      </nav>
    </section>

    <section class="intro-categoria container" v-if="categoria">
      <editor :object="categoria.body"></editor>
    </section>
    <section class="categorias-home" :par="childs.filter(e => e.featured == 1).length != 1" v-if="childs.length > 0">
    
      <div class="categorias container row-between">

        <article class="categoria-square -castillos-y-batallas column-between"
          :style="`background:url(${child.banner.url}) center/cover no-repeat`"
          v-for="(child, key) in categoria.childs" v-if="child.featured == 1">
          <div class="contenedor-imagen">
            <img v-if="child.logo" :src="child.logo.url" alt="Logo">
          </div>
          <a class="btn-skull">Ver actividades</a>
          <router-link :to="$t('enlaces.categoria')+'/'+child.slug" class="enlace-cover">Ir</router-link>
        </article>

      </div>
    </section>

    <section class="actividades-list container">

      <h2 class="big-title -xsmall column-center" :data="$route.params.id" :nocat="(!!!$route.params.id)">
        <strong>Actividades</strong>       
      </h2>

      <div id="selector_categoria_act" class="selector" :data="$route.params.id">
            <label for="actividadescategoria" style="display: none;">Actividades</label>
        <select v-model="data.categorie" aria-label="actividadescategoria">
          <option value="">Todas las actividades</option>
          <option :value="option.slug" v-if="option.visible == 1 && !option.mother_id" v-for="(option,key) in categorias">{{option.name}}</option>
        </select>


        <select v-model="data.subcategorie" v-if="childs && childs.length != 0" aria-label="Subcategoria">
          <option value="">Subcategoría</option>
          <option :value="option.slug" v-if="option.visible == 1" v-for="(option,key) in childs">{{option.name}}</option>
        </select>

        <button class="btn green" :data="$route.params.id" @click="getActividades">Buscar</button>

      </div>

      <template v-if="!!actividades">

        <template v-for="(dia,key) in actividades" v-if="actividades.length != 0">
          <h3 class="fecha" :data="$route.params.id">{{key | parse}}</h3>
          
          <template v-if="dia.length != 0">
            <actividad-el :key="keyactividad+key" v-for="(actividad,keyactividad) in dia" :data="actividad"
            :date="dia"></actividad-el>
          </template>  
          
        </template>

        <h3 v-if="actividades.length == 0" class="no-data" :data="$route.params.id">No hay actividades para las fechas
          seleccionadas</h3>

      </template>





    </section>


  </div>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import actividad from '@/components/parts/actividad-el';

  import Datepicker from 'vuejs-datepicker';

  import { en, es } from 'vuejs-datepicker/dist/locale'

  import Slick from 'vue-slick';

  import editor from '@/components/parts/editorJs'

  export default {
    name: 'categoria',
    mounted() {
      this.setData();
    },
    data() {
      return {
        actividades: '',
        en: en,
        es: es,
        data: {
          date_start: '',
          date_end: '',
          categorie: ''
        },
        disabledDates: {
          to: new Date(new Date().setDate(new Date().getDate() + 1)),
          from: new Date(2023, 0, 1)
        },
      }
    },
    methods: {
      ...mapActions(['requestActividades','ordenarActividades', 'requestCategoria']),
    getActividades() {
    this.requestActividades(this.data).then(r => {
      if (!!r) {
        // Llamar a ordenarActividades para ordenar las actividades
        this.ordenarActividades(r).then(actividadesOrdenadas => {
          this.actividades = actividadesOrdenadas;
        }); 
      } 
      if (!!this.$route.query.date_start) {
        $("html,body").animate({ scrollTop: $(".actividades-list").position().top });
      }
    }); 
},
      setData() {
        this.data.categorie = this.$route.params.id;
        (!!this.$route.query.date_start) ? this.data.date_start = this.$route.query.date_start : null;
        (!!this.$route.query.date_end) ? this.data.date_end = this.$route.query.date_end : null;
        this.getActividades();
      }
    },
    components: {
      'actividad-el': actividad,
      Datepicker,
      Slick,
      'editor': editor
    },
    computed: {
      ...mapGetters({
        categorias: 'getCategorias'
      }),
      categoria() {
        let categoria;
        if (this.categorias) {
          categoria = this.categorias.filter(e => e.slug == this.$route.params.id)[0];
        }

        return categoria;
      },
      childs() {

        let childs;

        if (this.categorias && this.categorias.length != 0) {
          if (this.categorias.filter(c => c.slug == this.data.categorie).length != 0) {
            childs = this.categorias.filter(c => c.slug == this.data.categorie)[0].childs;
          }
        }

        return childs;

      }
    },
    filters: {
      parse(value) {
        let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        let dias = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
        let date = new Date(value);

        return `${date.getDate()} de ${meses[date.getMonth()]} de ${date.getFullYear()}, ${dias[date.getDay()]}`;
      },
      parseNumber(value) {
        let date = new Date(value);
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      }
    },
    watch: {
      '$route'() {
        this.setData();
      },
      'data.categorie'(){
        this.data.subcategorie = '';
      }
    }
  }
</script>
<style lang="scss">
  .btn.-resonancia {
    display: inline-block;
    margin-bottom: 50px;
    height: 60px;
    line-height: 60px;
  }

  @media screen and (max-width:400px) {
    .btn.-resonancia {
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/categoria.vue